export type KeyValueMap<U extends string> = {
  [K in U]: K
}


export type LEAD_SOURCE = 'OTHERS' | 'WEB' | 'LEAD'
export const LEAD_SOURCE : KeyValueMap<LEAD_SOURCE> = {
  OTHERS : 'OTHERS',
  WEB    : 'WEB',
  LEAD   : 'LEAD'
}

export type LEAD_STAGE = 'LEAD'
export const LEAD_STAGE : KeyValueMap<LEAD_STAGE> = {
  LEAD   : 'LEAD'
}

export type USER_ROLE = ''


export enum TEXT_CASE {
  CAMEL       = 'CAMEL',           // camelCaseText
  PASCAL      = 'PASCAL',          // PascalCaseText
  SENTENCE    = 'SENTENCE',        // Sentence case
  UPPER       = 'UPPER',           // UPPERCASE
  LOWER       = 'LOWER',           // lower
  UPPER_CAMEL = 'UPPER_CAMEL',     // UpperCamelCaseText
  KEBAB       = 'KEBAB',           // kebab-case-text
  SNAKE       = 'SNAKE',           // snake_case
  UPPER_SNAKE = 'UPPER_SNAKE',     // UPPER_SNAKE_CASE
  TITLE       = 'TITLE'            // Title Case
}
